import React from 'react';
import styled from 'react-emotion';
import { PageOf } from './PageOf';
export const SearchMetaWrapper = styled('aside') `
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
`;
class SearchMeta extends React.PureComponent {
    render() {
        const { total, page, pages, className = '' } = this.props;
        return (React.createElement(SearchMetaWrapper, { className: className },
            React.createElement("header", null,
                total,
                " items"),
            React.createElement(PageOf, { page: page, pages: pages })));
    }
}
export default SearchMeta;
//# sourceMappingURL=SearchMeta.js.map